import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { Harvest } from 'src/app/core/models/supply-chain.interface';

@Component({
  selector: 'app-card-harvest-lot',
  templateUrl: './card-harvest-lot.component.html',
  styleUrls: ['./card-harvest-lot.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CardHarvestLotComponent {
  @Input() harvest: Harvest;
}
